import { render, staticRenderFns } from "./PreferenceComposant.vue?vue&type=template&id=6fe655c5"
import script from "./PreferenceComposant.vue?vue&type=script&lang=js"
export * from "./PreferenceComposant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports